import { styled } from '@mui/material/styles';
const PREFIX = 'TopBar';
export const classes = {
    root: `${PREFIX}-root`,
    toolbar: `${PREFIX}-toolbar`,
    title: `${PREFIX}-title`,
    notificationsButton: `${PREFIX}-notificationsButton`,
    toolbarButtons: `${PREFIX}-toolbarButtons`,
    toolbarAvatar: `${PREFIX}-toolbarAvatar`,
    toolbarUserInfo: `${PREFIX}-toolbarUserInfo`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        backgroundColor: theme.palette.background.paper,
        // borderRadius: theme.props?.MuiPaper?.style?.borderRadius,
        // overflow: 'hidden',
        borderWidth: 0,
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.primary.main,
    },
    [`& .${classes.toolbar}`]: {
        // borderBottom: `1px solid ${theme.palette.primary.light}`,
        // overflow: 'hidden',
        paddingLeft: 0,
    },
    [`& .${classes.title}`]: {
        fontSize: 24,
        fontWeight: 'bold',
        color: theme.palette.text.secondary,
    },
    [`& .${classes.notificationsButton}`]: {
        marginLeft: 'auto',
    },
    [`& .${classes.toolbarButtons}`]: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
    },
    [`& .${classes.toolbarAvatar}`]: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        marginLeft: theme.spacing(1),
    },
    [`& .${classes.toolbarUserInfo}`]: {
        textAlign: 'right',
    },
}));
export default Root;
//# sourceMappingURL=styled.js.map